import React from 'react';
import PropTypes from 'prop-types';

import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../lib/custom-scrollbar/custom-scrollbar';
import OEButton, {OEIconButton} from './controls/oe-button';
import {OECustomCheckbox} from './controls/oe-checkbox';
import OEIcon from '../elements/oe-icon';

export class OEFNSpacerElement extends React.PureComponent {
    render() {
        let height = '2.125em';
        if(typeof(this.props.height) === 'number')  {
            height = this.props.height.toString() + 'px';
        } else if(typeof(this.props.height) === 'string')  {
            height = OEFNSpacerElement.heights[this.props.height] ? OEFNSpacerElement.heights[this.props.height] : this.props.height;
        }
        return <div className={'flow-nav-spacer-element ' + this.props.className} style={{height: height}} />;
    }
}

OEFNSpacerElement.defaultProps = {
    className:              '',
    height:                 '2.125em'       // 34px
};

OEFNSpacerElement.propTypes = {
    className:              PropTypes.string,
    height:                 PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

OEFNSpacerElement.heights = {
    std:                    '2.125em',      // 34px
    top:                    '4.625em',      // 74px
    bottom:                 '6.625em'       // 106px
};

//
export class OEFNMenuElement extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.onSubBtnClick = this.onSubBtnClick.bind(this);
    }

    renderSubButton()   {
        if(!this.props.subButton)  return null;

        let {className, disabled, onClick, ...rest} = this.props.subButton;

        return (
            <OEIconButton
                {...rest}
                className={'flow-nav-menu-element-sub-btn ' + (className ? className : '')}
                disabled={!this.props.enabled || disabled}
                onPressed={this.onSubBtnClick}
            />
        );
    }

    render() {
        return (
            <div className={'flow-nav-menu-element ' + (this.props.enabled ? 'enabled ' : 'disabled ') + this.props.className}>
                <div className="flow-nav-menu-element-container">

                    <div className="left" onClick={this.onClick}>
                        {this.props.iconCode === '' ? null : <OEIcon code={this.props.iconCode}/>}
                        {this.props.leftContent}
                    </div>

                    <div className={'spacer ' + (this.props.iconCode === '' ? 'opaque' : '')} onClick={this.onClick}/>

                    <div className="main" onClick={this.onClick}>
                        {this.props.html ? <span dangerouslySetInnerHTML={{__html: this.props.html}}/> : <span>{this.props.title}</span>}

                        {this.props.children}
                    </div>

                </div>

                {this.renderSubButton()}

            </div>
        );
    }

    onClick()   {
        if(!this.props.enabled || !this.props.onClick)  return;
        this.props.onClick(this.props.id, this);
    }

    onSubBtnClick() {
        if(!this.props.enabled || !this.props.subButton || this.props.subButton.disabled || !this.props.subButton.onClick)  return;
        this.props.subButton.onClick(this.props.id, this);
    }
}

OEFNMenuElement.defaultProps = {
    id:                     '',
    className:              '',
    iconCode:               '',
    title:                  '',
    enabled:                true
};

OEFNMenuElement.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    iconCode:               PropTypes.string,
    title:                  PropTypes.string,
    html:                   PropTypes.string,
    enabled:                PropTypes.bool,
    subButton: PropTypes.shape({
        className:          PropTypes.string,
        iconClassName:      PropTypes.string,
        disabled:           PropTypes.bool,
        icon:               PropTypes.string,
        tooltipClassName:   PropTypes.string,
        tooltipPlacement:   PropTypes.string,
        tooltip:            PropTypes.node,
        disabledTooltip:    PropTypes.node,
        onClick:            PropTypes.func
    }),
    onClick:                PropTypes.func
};

//
export class OEFNButtonElement extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        return (
            <div className={'flow-nav-button-element ' + this.props.className}>
                <OEButton
                    disabled={!this.props.enabled}
                    onPressed={this.onClick}
                >
                    {this.props.title}
                </OEButton>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNButtonElement.defaultProps = {
    id:                     '',
    className:              '',
    title:                  '',
    enabled:                true
};

OEFNButtonElement.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    title:                  PropTypes.string,
    enabled:                PropTypes.bool,
    onClick:                PropTypes.func
};

//
export class OEFNCheckboxElement extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        const subtitle = this.props.subtitle;
        return (
            <div className={'flow-nav-checkbox-element ' + this.props.className}>
                <OECustomCheckbox checked={this.props.checked} onPressed={this.onClick}/>
                <div className="title">
                    <span className="primary-title">{this.props.title}</span>
                    {!subtitle || !subtitle.length ? null : <span className="sub-title">{subtitle}</span>}
                </div>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNCheckboxElement.defaultProps = {
    id:                     '',
    className:              '',
    title:                  '',
    checked:                false
};

OEFNCheckboxElement.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    iconCode:               PropTypes.string,
    title:                  PropTypes.string,
    subtitle:               PropTypes.string,
    checked:                PropTypes.bool,
    onClick:                PropTypes.func
};

//
export class OEFNHyperlinkElement extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        return (
            <div className={'flow-nav-hyperlink-element ' + this.props.className}>
                <span>{this.props.label}</span>
                <a href={this.props.href} onClick={this.props.onClick ? this.onClick : null}>
                    {this.props.title ? this.props.title : this.props.href}
                </a>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNHyperlinkElement.defaultProps = {
    id:                     '',
    className:              '',
    label:                  ''
};

OEFNHyperlinkElement.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    label:                  PropTypes.string,
    title:                  PropTypes.string,
    href:                   PropTypes.string,
    onClick:                PropTypes.func
};

//
export class OEFNChapter extends React.PureComponent {
    render() {
        return (
            <div className={'flow-nav-chapter ' + this.props.className}>
                <span className="title">{this.props.title}</span>
                <div className="body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

OEFNChapter.defaultProps = {
    className:              '',
    title:                  ''
};

OEFNChapter.propTypes = {
    className:              PropTypes.string,
    title:                  PropTypes.string
};

//
export class OEFNParagraph extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        var noChild = !this.props.children || !this.props.children.length;
        var noIcon = this.props.iconCode === '';

        return (
            <div className={'flow-nav-paragraph ' + (noChild ? 'empty ' : '') + (noIcon ? 'no-icon ' : '') + this.props.className}>
                <div className="title-bar">
                    <div className="left" onClick={this.onClick}>
                        {noIcon ? null : <OEIcon code={this.props.iconCode}/>}
                    </div>

                    <div className="main" onClick={this.onClick}>
                        {this.props.title}
                    </div>

                    <div className="right" onClick={this.onClick}>
                    </div>
                </div>
                <div className="body">
                    {this.props.children}
                </div>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNParagraph.defaultProps = {
    id:                     '',
    className:              '',
    iconCode:               '',
    title:                  ''
};

OEFNParagraph.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    iconCode:               PropTypes.string,
    title:                  PropTypes.string,
    onClick:                PropTypes.func
};

//
export class OEFNStdParagraphItem extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        var noIcon = this.props.iconCodeLeft === '' && this.props.iconCodeRight === '';

        return (
            <div className={'flow-nav-std-item ' + (noIcon ? 'no-icon ' : '') + this.props.className}>
                <div className="left" onClick={this.onClick}>
                    {this.props.iconCodeLeft === '' ? null : <OEIcon code={this.props.iconCodeLeft}/>}
                    {this.props.iconElementLeft}
                </div>

                <div className="main" onClick={this.onClick}>
                    <span>{this.props.title}</span>
                </div>

                <div className="right" onClick={this.onClick}>
                    {this.props.iconCodeRight === '' ? null : <OEIcon code={this.props.iconCodeRight}/>}
                    {this.props.iconElementRight}
                </div>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNStdParagraphItem.defaultProps = {
    id:                     '',
    className:              '',
    iconCodeLeft:           '',
    title:                  '',
    iconCodeRight:          ''
};

OEFNStdParagraphItem.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    iconCodeLeft:           PropTypes.string,
    title:                  PropTypes.string,
    iconCodeRight:          PropTypes.string,
    onClick:                PropTypes.func
};

//
export class OEFNStdParagraphSubItem extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        return (
            <div className={'flow-nav-std-sub-item ' + this.props.className}>
                <div className="left" onClick={this.onClick}>
                    {this.props.iconCode === '' ? null : <OEIcon code={this.props.iconCode}/>}
                    {this.props.iconElement}
                </div>

                <div className="main" onClick={this.onClick}>
                    {this.props.html ? <span dangerouslySetInnerHTML={{__html: this.props.html}}/> : <span>{this.props.title}</span>}
                </div>
            </div>
        );
    }

    onClick()   {
        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNStdParagraphSubItem.defaultProps = {
    id:                     '',
    className:              '',
    iconCode:               '',
    title:                  ''
};

OEFNStdParagraphSubItem.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    iconCode:               PropTypes.string,
    title:                  PropTypes.string,
    html:                   PropTypes.string,
    onClick:                PropTypes.func
};

//
export class OEFNBlock extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render() {
        return (
            <div className={'flow-nav-block ' + this.props.className + (this.props.disabled ? ' disabled' : '')} style={this.props.style} onClick={this.onClick}>
                {this.props.html ? <span dangerouslySetInnerHTML={{__html: this.props.content}}/> : <span>{this.props.content}</span>}
                {this.props.children}
            </div>
        );
    }

    onClick()   {
        if(this.props.disabled) {
            if(this.props.onDisabledClick)  this.props.onDisabledClick(this.props.id, this);
            return;
        }

        if(this.props.onClick)  this.props.onClick(this.props.id, this);
    }
}

OEFNBlock.defaultProps = {
    id:                     '',
    className:              ''
};

OEFNBlock.propTypes = {
    id:                     PropTypes.string,
    className:              PropTypes.string,
    style:                  PropTypes.object,
    html:                   PropTypes.bool,
    disabled:               PropTypes.bool,
    onClick:                PropTypes.func,
    onDisabledClick:        PropTypes.func,
};

//
export class OEFNSeparator extends React.PureComponent {
    render() {
        return (
            <div className={'flow-nav-separator ' + this.props.className} />
        );
    }
}

OEFNSeparator.defaultProps = {
    className:              ''
};

OEFNSeparator.propTypes = {
    className:              PropTypes.string
};

//
export class OEFNView extends React.PureComponent {
    render() {
        return (
            <div className={'flow-nav-view ' + this.props.className}>
                <CustomScrollbar
                    horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                    verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                >
                    <div className="flow-nav-view-content flow-nav-view-content-colors">
                        {this.props.children}
                    </div>
                </CustomScrollbar>
            </div>
        );
    }
}

OEFNView.defaultProps = {
    className:              ''
};

OEFNView.propTypes = {
    className:              PropTypes.string
};

//
export class OESelectionBarCell extends React.PureComponent {

    constructor(props)  {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render()    {
        return (
            <div className={'flow-nav-selection-bar-cell' + (this.props.selected ? ' selected' : '') + (this.props.disabled ? ' disabled' : '')} onClick={this.onClick}>
                <div className="cell-border"/>
                <div className="container">
                    {!this.props.icon ? null :
                       <OEIcon code={this.props.icon}/>
                    }
                    {!this.props.label ? null :
                        <div className="label">
                            {this.props.label}
                        </div>
                    }
                    {this.props.content}
                </div>
            </div>
        );
    }

    onClick(e) {
        if(this.props.onClick)  this.props.onClick(this);
    }
};

OESelectionBarCell.defaultProps = {};

OESelectionBarCell.propTypes = {
    label:                  PropTypes.string,
    icon:                   PropTypes.string,
    content:                PropTypes.node,
    selected:               PropTypes.bool,
    disabled:               PropTypes.bool,
    onClick:                PropTypes.func
};

//
export class OEFNSelectionBar extends React.PureComponent {

    constructor(props) {
        super(props);
        this.onCellClick = this.onCellClick.bind(this);
    }

    renderCells()   {
        return !this.props.items ? null : this.props.items.map((item, index) => {
            let id = typeof(item.id) === 'string' ? item.id : index;
            return (
                <OESelectionBarCell
                    key={index}
                    id={id}
                    label={item.label}
                    icon={item.icon}
                    content={item.content}
                    selected={id === this.props.selected}
                    disabled={item.disabled}
                    onClick={this.onCellClick}
                />
            );
        });
    }

    render() {
        return (
            <div className={'flow-nav-selection-bar ' + this.props.className + (this.props.disabled ? ' disabled' : '')}>
                {this.renderCells()}
            </div>
        );
    }

    onCellClick(sender) {
        if(this.props.disabled) return;
        if(this.props.onItemClick)  this.props.onItemClick(this, sender.props.id);
    }
}

OEFNSelectionBar.defaultProps = {
    className:              ''
};

OEFNSelectionBar.propTypes = {
    className:              PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
        id:                 PropTypes.string,
        label:              PropTypes.string,
        icon:               PropTypes.string,
        content:            PropTypes.node,
        disabled:           PropTypes.bool
    })),
    selected:               PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled:               PropTypes.bool,
    onItemClick:            PropTypes.func
};

//
const OEFNElement = {
    Spacer:                 OEFNSpacerElement,
    Menu:                   OEFNMenuElement,
    Button:                 OEFNButtonElement,
    Checkbox:               OEFNCheckboxElement,
    Hyperlink :             OEFNHyperlinkElement,
    Chapter:                OEFNChapter,
    Paragraph:              OEFNParagraph,
    StdParagraphItem:       OEFNStdParagraphItem,
    StdParagraphSubItem:    OEFNStdParagraphSubItem,
    Block:                  OEFNBlock,
    Separator:              OEFNSeparator,
    View:                   OEFNView,
    SelectionBar:           OEFNSelectionBar
};

export default OEFNElement;